<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-18 14:24:52
 * @LastEditors: lau
 * @LastEditTime: 2022-08-18 14:47:28
-->
<!-- 查询线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
  
            },
            responseCode: {
                
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询月票凭证记录列表",
                t_url: this.commonUrls.test + "getMonthTicketCertifiRuleList",
                p_url: this.commonUrls.prod + "getMonthTicketCertifiRuleList",
                precondition: "无",
                fitSystem: "云停车场，传统停车场（线上开通的月票）",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编号列表' },
                        { info1: 'certifiRuleId', info2: '否', info3: 'Long', info4: '' },
                        { info1: 'monthTicketConfigIds', info2: '否', info3: 'Long[]', info4: '月票类型ID' },
                        { info1: 'name', info2: '否', info3: 'String', info4: '凭证名称' },
                        { info1: 'createTimeFrom', info2: '否', info3: 'String', info4: '凭证创建起始时间，yyyyMMddHHmmss' },
                        { info1: 'createTimeTo', info2: '否', info3: 'String', info4: '凭证创建截止时间，yyyyMMddHHmmss' },
                        { info1: 'updateTimeFrom', info2: '否', info3: 'String', info4: '凭证更新起始时间，yyyyMMddHHmmss' },
                        { info1: 'updateTimeTo', info2: '否', info3: 'String', info4: '凭证更新截止时间，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多1000条' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '月票列表' },
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '总张数' },
                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '月票凭证id' },
                        { info1: 'certifiName', info2: '否', info3: 'String', info4: '凭证名称' },
                        { info1: 'certifiDesc', info2: '否', info3: 'String', info4: '凭证说明' },
                        { info1: 'agreementId', info2: '否', info3: 'Long', info4: '停车场协议ID' },
                        { info1: 'agreementContent', info2: '否', info3: 'String', info4: '协议内容' },
                        { info1: 'agreementTitle', info2: '否', info3: 'String', info4: '协议标题' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '车场编号' },
                        { info1: 'parkName', info2: '否', info3: 'String', info4: '车场名称' },
                        { info1: 'applyMonthTicketConfigList', info2: '否', info3: 'JSONAarry', info4: '适用的月票类型列表' },
                        { info1: 'createTime', info2: '否', info3: 'String', info4: '创建时间yyyyMMddHHmmss' },
                        { info1: 'updateTime', info2: '否', info3: 'String', info4: '更新时间yyyyMMddHHmmss' },
                        { info1: 'certifiStatus', info2: '否', info3: 'Integer', info4: '状态(0关闭，1开启)' },
                        { info1: 'certifiSampleUrl', info2: '否', info3: 'String', info4: '凭证样例url' },
                        { info1: 'monthTicketConfigIds', info2: '否', info3: 'Long[]', info4: '月票类型 ID 列表' },

					   ]
                },{
                    titleName: 'applyMonthTicketConfigList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'monthTicketConfigId', info2: '是', info3: 'Long', info4: '月票类型id' },
                        { info1: 'monthTicketConfigName', info2: '是', info3: 'String', info4: '月票类型名称' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/getMonthTicketCertifiRuleList.vue